import Vue from 'vue'
import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'
import env from '@tencent/vft-common/env'

if(process.env.NODE_ENV==='production'){
  Raven
    .config('https://1604bd68d71b42728a72cd4924354108@report.url.cn/sentry/891', {
      release: '1',
      ignoreErrors: ['WebViewJavascriptBridge', 'WeixinJSBridge is not defined', /Script error.*/],
      sampleRate: 0.01 // 采样率
    })
    .addPlugin(RavenVue, Vue)
    .install()
    .setExtraContext({
      env: `${env.device}.${env.app}`
    })
}

